import './assets/Layout.css';const _ = "_label_pqd5x_17", o = "_description_pqd5x_23", s = "_input_pqd5x_29", d = "_loading_pqd5x_82", e = "_readonly_pqd5x_98", t = "_errored_pqd5x_105", i = "_disabled_pqd5x_108", n = "_prefix_pqd5x_122", p = "_suffix_pqd5x_123", r = "_message_pqd5x_160", l = {
  "form-field-layout": "_form-field-layout_pqd5x_9",
  label: _,
  "component-slot": "_component-slot_pqd5x_20",
  description: o,
  "input-layout": "_input-layout_pqd5x_29",
  "input-list": "_input-list_pqd5x_29",
  input: s,
  loading: d,
  readonly: e,
  errored: t,
  disabled: i,
  prefix: n,
  suffix: p,
  "action-suffix": "_action-suffix_pqd5x_151",
  "error-msg": "_error-msg_pqd5x_160",
  message: r
};
export {
  l as s
};
